<template>
    <vx-card title="Редактирование настройки" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Наименование"
                        placeholder="Введите наименование..."
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.value"
                        :danger="!!errors.value"
                        :danger-text="errors.value"
                        autocomplete="off"
                        label="Значение"
                        placeholder="Введите значение..."
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/3">
                <label class="vs-input--label required">
                    Окружение
                </label>
                <v-select
                    :options="dicts.zones"
                    label="name"
                    placeholder="Выберите окружение"
                    class="w-full"
                    v-model="form.zone"
                    :reduce="z => z.id"
                    :clearable="false">
                </v-select>
            </div>
        </div>

        <vs-button class="mt-5 mr-2" color="success" @click="saveSetting()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
    import vSelect from 'vue-select';
    import axios from 'axios';

    export default {
        name: 'settings-it-edit',   
        props: ['id'],
        data() {
            return {
                setting: undefined,
                form: {
                    name: undefined,
                    value: undefined,
                    zone: undefined
                },
                dicts: {
                    zones: []
                },
                errors: {
                    name: '',
                    value: '',
                    zone: ''
                }
            }
        },
        components: {
            'v-select': vSelect
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                this.axios
                    .all([
                        this.axios.get("settings-it/dicts", {}),
                        this.axios.get('settings-it/' + this.id)
                    ])
                    .then(
                        axios.spread((dicts, setting) => {
                            this.setting = setting.data;
                            this.form.name = setting.data.name;
                            this.form.value = setting.data.value;
                            this.form.zone = setting.data.zoneId;
                            this.dicts.zones = dicts.data.zones;
                        })
                    )
                    .catch((err) => {
                        this.$vs.notify({
                            title: "Ошибка!",
                            text: "Ошибка загрузки вспомогательной информации.",
                            color: "danger",
                        });
                    })
                    .finally(() => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                    });
            },
            saveSetting() {
                this.$vs.loading({
                    container: '#loader',
                    type: 'sound'
                });

                const params = {
                    id: this.id,
                    name: this.form.name,
                    value: this.form.value,
                    zoneId: this.form.zone
                }

                this.$axios({
                    method: 'PUT',
                    url: 'settings-it/' + this.id,
                    params: params,
                    errors: this.errors,
                    success: (setting) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        this.$vs.notify({
                            title: "Успешно обновлено",
                            text: "Настройка успешно обновлена",
                            color: "success",
                        });
                        this.$router.push('/settings-it');
                    },
                    catch: (err) => {
                        this.$vs.loading.close("#loader > .con-vs-loading");
                        return this.$vs.notify({
                            title: "Внимание!",
                            text: "Ошибка при редактировании настройки!",
                            color: "danger",
                        });
                    }
                })
            },
            cancelEdit() {
                this.$router.push('/settings-it');
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style>
    .select-error > div {
        border: 1px solid rgba(var(--vs-danger),1)!important;
    }
</style>